export const NEW_NOTIFICATIONS_BETA = 'new_notifications'
export const OWN_CONTRACT_SUPPORT = 'support_own_contract_tickets'
export const INSURANCE_TAB_SUPPORT = 'support_insurance_automation'
